import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Check, AlertTriangle, Upload, Loader2 } from "lucide-react";
import "./carga.css";

export const py = (n) => (n === null || n === undefined ? "—" : Number(n).toLocaleString("es-PY", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
const TIPOS = [
  ["cuentas", "Cuentas a recibir", "Foto del día: reemplaza facturas abiertas"],
  ["cobros", "Cobros por vendedor", "Cobrado del mes (reemplaza el mes)"],
  ["pagares", "Pagarés registrados", "No firmados; los que desaparecen = firmados"],
  ["lineas", "Líneas de crédito", "Líneas, deuda y disponible (con historial)"],
  ["garantias", "Garantías reales", "Bienes activos, tasación y rangos"],
];

export const Casilleros = ({ estado, onCambio }) => {
  const [subiendo, setSubiendo] = useState({});
  const timer = useRef(null);
  const procesando = Object.values(estado?.casilleros || {}).some((c) => c && c.estado === "procesando");
  useEffect(() => {
    if (!procesando) return;
    timer.current = setTimeout(onCambio, 1500);
    return () => clearTimeout(timer.current);
  }, [estado, procesando]);  // eslint-disable-line react-hooks/exhaustive-deps

  const subir = async (tipo, file) => {
    if (!file) return;
    setSubiendo((s) => ({ ...s, [tipo]: true }));
    const fd = new FormData(); fd.append("tipo", tipo); fd.append("file", file);
    try { await api.post("/carga-central/subir", fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success(`${file.name} recibido, procesando…`); onCambio(); }
    catch (e) { toast.error(e.response?.data?.detail || "No se pudo subir"); }
    finally { setSubiendo((s) => ({ ...s, [tipo]: false })); }
  };

  return (
    <div className="cc-casilleros" data-testid="cc-casilleros">
      {TIPOS.map(([id, titulo, desc]) => {
        const c = estado?.casilleros?.[id];
        const est = !c ? "idle" : c.estado === "procesando" ? "idle" : c.estado === "error" ? "err" : c.cuadra === false ? "warn" : "ok";
        return (
          <div className="cc-cas" key={id} data-testid={`cc-cas-${id}`}>
            <h4>{titulo}</h4>
            <span className={`est ${est}`} data-testid={`cc-estado-${id}`}>
              {!c ? "Sin archivo" : c.estado === "procesando" ? <><Loader2 className="h-3 w-3 animate-spin" /> Leyendo… {c.progreso}%</> : c.estado === "error" ? <><AlertTriangle className="h-3 w-3" /> Error</>
                : c.cuadra === false ? <><AlertTriangle className="h-3 w-3" /> Leído · no cuadra</> : <><Check className="h-3 w-3" /> Leído {c.cuadra ? "· cuadra" : ""}</>}
            </span>
            {c?.estado === "procesando" && <div className="riel"><i style={{ width: `${c.progreso}%` }} /></div>}
            {c?.estado === "listo" && <>
              <div className="dato">Filas <b>{c.filas}</b> · Total <b>US$ {py(c.total)}</b></div>
              {c.total_pdf !== null && c.total_pdf !== undefined && <div className="dato" data-testid={`cc-impreso-${id}`}>Impreso {c.cantidad_pdf ? <><b>{c.cantidad_pdf}</b> · </> : null}<b>US$ {py(c.total_pdf)}</b></div>}
              <div className="dato">Corte <b>{c.corte || "—"}</b> · {c.nombre}</div>
            </>}
            {c?.estado === "error" && <div className="dato cc-rojo">{c.error}</div>}
            {!c && <div className="dato">{desc}</div>}
            <label className="sub"><input type="file" accept="application/pdf" data-testid={`cc-input-${id}`} onChange={(e) => subir(id, e.target.files?.[0])} />
              {subiendo[id] ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Upload className="h-4 w-4 mr-1" /> {c ? "Reemplazar PDF" : "Subir PDF"}</>}</label>
          </div>
        );
      })}
    </div>
  );
};

export const Diagrama = () => (
  <div className="cc-diagrama" data-testid="cc-diagrama">
    <ul className="izq"><li>Cuentas a recibir<small>código de cliente · vendedor · coordinador</small></li><li>Cobros<small>código de cliente · vendedor</small></li></ul>
    <div className="llave">Código<br />de cliente<br /><small style={{ fontWeight: 500 }}>(llave)</small></div>
    <ul className="der"><li>Líneas de crédito<small>código · vendedor por código</small></li><li>Garantías reales<small>código de cliente</small></li><li className="punteada">Pagarés<small>por nombre / RUC → alias guardado</small></li></ul>
  </div>
);
